// extracted by mini-css-extract-plugin
export var copyIcon = "_sg-2";
export var discountCard = "_sg-0";
export var discountCode = "_sg-3";
export var discountContent = "_sg-1";
export var loadingCard = "_sg-4";